export default "__VITE_ASSET__DKh7b3Wm__"